let domLoaded = false;
let igReady = false;

function handleExperiments() {
  if (!domLoaded || !igReady) return;

  const cartDrawerMvt = window.igData?.user.getTestGroup(
    "0295e0cd-0c39-4fe0-933c-d784206b6b14"
  );
  if (cartDrawerMvt?.name === "Var A - Minimal") {
    document.body.classList.add("c-cartDrawerMvtVarA");
  } else if (cartDrawerMvt?.name === "Var B - Upsell") {
    document.body.classList.add("c-cartDrawerMvtVarB");
  } else if (cartDrawerMvt?.name === "Var C - Outcome strip") {
    document.body.classList.add("c-cartDrawerMvtVarC");
  } else if (cartDrawerMvt?.name === "Var D - Real urgency") {
    document.body.classList.add("c-cartDrawerMvtVarD");
  }

  // Test: V_CM_NAV_03 - Navigation MVT
  // Var A - Visual Bestsellers | Var B - Quick-Shop | Var C - Combined (Search + Bestsellers + Quick-Buy)
  const navMvt03 = window.igData?.user.getTestGroup(
    "6bcecc09-e4b2-4bdb-a5c6-cbede5f5e204"
  );
  if (navMvt03?.name === "Var A - Visual Bestsellers") {
    document.body.classList.add("c-navMvt03VarAVisualBestsellers");
  } else if (navMvt03?.name === "Var B - Quick-Shop") {
    document.body.classList.add("c-navMvt03VarBQuickShop");
  } else if (navMvt03?.name === "Var C - Combined") {
    document.body.classList.add("c-navMvt03VarCCombined");
  } else {
    document.body.classList.add("c-navMvt03Control");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  domLoaded = true;
  handleExperiments();
});

window.addEventListener("ig:ready", () => {
  igReady = true;
  handleExperiments();
});
